import React from 'react';
import { useTranslation } from 'services/localization';
import Banner from 'components/Banner';

interface Props {
	mt?: number;
	mb?: number;
}

const LateReturnBanner = ({ mt, mb }: Props) => {
	const { t } = useTranslation();
	return (
		<Banner
			mt={mt}
			mb={mb}
			variant="warning"
			title={t('lateReturn.title', 'Late return')}
			description={t('lateReturn.info', 'Some products are late')}
		/>
	);
};

export default LateReturnBanner;
